export const ORG_TYPES = [
  {name: 'ВСЕ', value: '0'},
  {name: 'Без школ', value: '1'},
  {name: 'Школы', value: '2'},
]

export const COMMISSION_PLACES_EXPERT = [
  {value: 'member', name: 'Член комиссии'},
  {value: 'chairman', name: 'Председатель Аттестационной комиссии Министерства обороны Российской Федерации'},
  {value: 'deputy', name: 'Заместитель председателя Аттестационной комиссии Министерства обороны Российской Федерации'},
  {value: 'secretary', name: 'Секретарь Аттестационной комиссии Министерства обороны Российской Федерации'},
]

export const COMMISSION_PLACES_GUK = [
  {value: 'member', name: 'Член комиссии'},
  {value: 'chairman', name: 'Председатель комиссии'},
  {value: 'deputy', name: 'Заместитель председателя комиссии'},
  {value: 'secretary', name: 'Секретарь комиссии'},
]

export const ACCESS_LOGINS = ['iv-kurchatoff', 'uvo']
